import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import s from './LandingHeader.css';
import btn from '../shared/landingButtons.css';
import cs from '../../commonStyle.css';
import messages from '../../../locale/messages';
import history from '../../../core/history';
import { openLoginModal, openSignupModal, openHeaderModal } from '../../../actions/modalActions';

import currencyIcon from '../../../../images/new-landing/currency-icon-orange.svg';
import logo from '../../../../images/new-landing/logo.png';
const NAV_ITEMS = [
  { href: '/#explore', message: messages.newLandingExplore },
  { href: '/#about', message: messages.newLandingAboutUs },
  { href: '/#owners', message: messages.newLandingListYourCar },
  { href: '/#contact', message: messages.newLandingContact },
];

class LandingHeader extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    openLoginModal: PropTypes.func.isRequired,
    openSignupModal: PropTypes.func.isRequired,
    openHeaderModal: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false,
    };
  }
  componentWillUnmount() {
    document.body.classList.remove('headerModalOpen');
  }
  openMobileMenu = () => {
    this.setState({ mobileMenuOpen: true });
    document.body.classList.add('headerModalOpen');
  };
  closeMobileMenu = () => {
    this.setState({ mobileMenuOpen: false });
    document.body.classList.remove('headerModalOpen');
  };
  toggleMobileMenu = () => {
    if (this.state.mobileMenuOpen) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  };

  handleLogoClick = (event) => {
    event.preventDefault();
    this.closeMobileMenu();

    if (history.location.pathname !== '/') {
      history.push('/');
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  handleLoginClick = (event) => {
    event.preventDefault();
    this.closeMobileMenu();
    this.props.openLoginModal();
  };

  handleRegisterClick = (event) => {
    event.preventDefault();
    this.closeMobileMenu();
    this.props.openSignupModal();
  };

  handleLanguageCurrencyClick = (event) => {
    event.preventDefault();
    this.closeMobileMenu();
    this.props.openHeaderModal('languageModal');
  };
  handleNavLinkClick = () => {
    this.closeMobileMenu();
  };
  renderNavLinks = (linkClassName) => (
    NAV_ITEMS.map((item) => (
      <li key={item.href}>
        <a href={item.href} className={linkClassName} onClick={this.handleNavLinkClick}>
          <FormattedMessage {...item.message} />
        </a>
      </li>
    ))
  );

  render() {
    const { intl } = this.props;
    const { mobileMenuOpen } = this.state;

    return (
      <>
        <nav className={s.navbar}>
          <a href="/" className={s.navLogo} onClick={this.handleLogoClick}>
            <img
              src={logo}
              alt={intl.formatMessage(messages.newLandingMotoStreamLogoAlt)}
              draggable={false}
            />
          </a>
          <ul className={s.navLinks}>
            {this.renderNavLinks()}
          </ul>
          <div className={s.navButtons}>
            <a
              href="#"
              role="button"
              onClick={this.handleLanguageCurrencyClick}
              className={s.languageCurrencyLink}
            >
              <FormattedMessage {...messages.languageCurrency} />
            </a>
            <a
              href="#"
              role="button"
              onClick={this.handleLoginClick}
              className={cx(btn.landingBtn, btn.landingBtnOutline, s.navSignIn)}
            >
              {intl.formatMessage(messages.newLandingSignIn)}
            </a>
            <a
              href="#"
              role="button"
              onClick={this.handleRegisterClick}
              className={cx(btn.landingBtn, btn.landingBtnNavPrimary, s.navRegister)}
            >
              {intl.formatMessage(messages.newLandingRegister)}
            </a>
          </div>
          {/* hamburger menu toggle (shown ≤900px when desktop nav links hidden) */}
          <button
            type="button"
            className={s.menuToggle}
            onClick={this.toggleMobileMenu}
            aria-label={intl.formatMessage(messages.newLandingOpenMenu)}
            aria-expanded={mobileMenuOpen}
          >
            <span className={s.menuToggleIcon} aria-hidden="true">
              <span className={s.menuToggleBar} />
            </span>
          </button>
        </nav>

        {/* mobile slide-in nav (≤900px) */}
        <div
          className={cx(s.mobileMenuOverlay, { [s.mobileMenuOverlayOpen]: mobileMenuOpen })}
          onClick={this.closeMobileMenu}
          aria-hidden={!mobileMenuOpen}
        />

        <div
          className={cx(s.mobileMenu, { [s.mobileMenuOpen]: mobileMenuOpen })}
          aria-hidden={!mobileMenuOpen}
        >
          <div className={s.mobileMenuHeader}>
            <span className={s.mobileMenuTitle}>
              <FormattedMessage {...messages.newLandingMenu} />
            </span>
            <button
              type="button"
              className={s.mobileMenuClose}
              onClick={this.closeMobileMenu}
              aria-label={intl.formatMessage(messages.close)}
            >
              ×
            </button>
          </div>
          <ul className={s.mobileMenuLinks}>
            {this.renderNavLinks(s.mobileMenuLink)}
          </ul>
        </div>
        <button
          type="button"
          className={cx(s.languageIcon, 'notranslate')}
          onClick={this.handleLanguageCurrencyClick}
          aria-label={intl.formatMessage(messages.languageAndCurrency)}
        >
          <img src={currencyIcon} alt="" />
        </button>
      </>
    );
  }
}

const mapDispatch = {
  openLoginModal,
  openSignupModal,
  openHeaderModal,
};

export default compose(
  injectIntl,
  connect(null, mapDispatch),
  withStyles(s, btn, cs),
)(LandingHeader);
